import { AmlStatusEnum, InvestorName, UpliftStatusEnum, RestrictionStatusEnum } from "../../model";
import moment from "moment";

type upliftListCounts = {
    [k in AmlStatusEnum]: number;
};

export type UpliftTrackerOverview = {
  adviser: string;
  investorId: string;
  upliftDate: string;
  plannedDate: string;
  deadLineDate: string;
  upliftStatus: UpliftStatusEnum;
  kycInfo: string;
  amlStatus: AmlStatusEnum;
  considerations: string;
  RCFlag: string;
  RIFlag: string;
  PCLSFlag: string;
  industryText: string;
  occupationText: string;
  salaryText: string;
  restrictions: RestrictionStatusEnum
} & InvestorName;

export type UpliftTrackerListResponse = {
  total: number;
  counts: upliftListCounts,
  rows: UpliftTrackerOverview[]
};

export function upliftTrackerTransformer(response: any): UpliftTrackerListResponse {
  return {
    total: response.total,
    counts: response.statusCount,
    rows: response.rows.map(upliftTrackerListItemTransformer)
  };
}

export function upliftTrackerListItemTransformer(row: any): UpliftTrackerOverview {
  return {
    entityType: row.entityType,
    entityName: row.entityName,
    title: row.title,
    firstName: row.firstName,
    middleName: row.middleName,
    surname: row.surname,
    adviser: row.adviser || "-",
    investorId: row.personId,
    upliftDate: Number(row.plannedDate) ? moment(row.plannedDate, "YYYYMMDD").format("DD/MM/YYYY") : "-",
    plannedDate: Number(row.plannedDate) ? moment(row.plannedDate, "YYYYMMDD").format("DD/MM/YYYY") : "-",
    upliftStatus: row.upliftStatus,
    kycInfo: row.kycInfo || "-",
    amlStatus: row.amlStatus,
    deadLineDate: Number(row.deadLineDate) ? moment(row.deadLineDate, "YYYYMMDD").format("DD/MM/YYYY") : "-",
    considerations: row.consideration || "-",
    RCFlag: row.RCFlag ? "Y" : "N",
    RIFlag: row.RIFlag ? "Y" : "N",
    PCLSFlag: row.PCLSFlag ? "Y" : "N",
    industryText: row.industryText || "-",
    occupationText: row.occupationText || "-",
    salaryText: row.salaryText || "-",
    restrictions: row.restrictions || "-"
  };
}
